import { IUpdateVerbaPagamentoUseCase } from "../../../presentation/useCases/update/update_verba_pagamento_use_case";
import { IRhRepository } from "../../repositories/rh_repository";

/**
 * UpdateVerbaPagamentoUseCase
 */

export class UpdateVerbaPagamentoUseCase implements IUpdateVerbaPagamentoUseCase {
  constructor(private readonly repository: IRhRepository) { }

  async updateVerbaPagamento(
    idItemVerba: number,
    ativo: boolean,
    tipo: number,
    nro: string | null,
    verba: string,
    valor: number | null,
  ): Promise<void> {
    await this.repository.updateVerbaPagamento(
      idItemVerba,
      ativo,
      tipo,
      nro,
      verba,
      valor,
    );
  }
}
